/* file description */

import { UseScrollProp } from './type';

export const useScrollProp: UseScrollProp = ({ scroll }) => {
  return {
    mergeScroll: {
      x: 'max-content',
      ...(scroll || {}),
    },
  };
};
